(function () {
  'use strict';

  // OrbitaClick 02-11-2026: textos por idioma (ES por defecto, FR, PT) segun <html lang>
  var _ocl = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  var _ocT = function (es, fr, pt) { return _ocl.indexOf('fr') === 0 ? fr : (_ocl.indexOf('pt') === 0 ? pt : es); };
  var LABEL = _ocT('Comprar ya', 'Acheter', 'Comprar já');
  var TITLE = _ocT('Comprar ya. Te llevamos directo al pago.', 'Acheter. Accès direct au paiement.', 'Comprar já. Direto para o pagamento.');
  var pending = false;

  function isExcluded(form) {
    return !!form.closest('#side-cart, .side-cart, [data-cart-upsell], .cart-upsell, #CartDrawer');
  }

  function build(form) {
    if (form.dataset.ocBuynowCard) return;
    var atc = form.querySelector('button[type="submit"].overlay-buy_button');
    if (!atc) return;
    if (isExcluded(form)) return;

    form.dataset.ocBuynowCard = '1';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'oc-buynow-card';
    btn.textContent = LABEL;
    btn.title = TITLE;
    btn.setAttribute('aria-label', TITLE);

    var err = document.createElement('span');
    err.className = 'oc-buynow-card__err';
    err.setAttribute('role', 'alert');
    err.hidden = true;

    var anchor = atc.parentNode;
    anchor.insertBefore(btn, atc.nextSibling);
    anchor.insertBefore(err, btn.nextSibling);

    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      err.hidden = true;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = _ocT('Un momento…', 'Un instant…', 'Um momento…');
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () {
          // OrbitaClick 16-10-2026: si el pedido no llega a 20 € (envío gratis), al carrito
          // para que vea la barra "te faltan X €" y los complementos; si llega, directo al pago.
          return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (cart) {
              var bajoUmbral = cart && typeof cart.total_price === 'number' && cart.total_price < 2000;
              window.location.assign(bajoUmbral ? '/cart' : '/checkout');
            })
            .catch(function () { window.location.assign('/checkout'); });
        })
        .catch(function (e) {
          btn.disabled = false;
          btn.textContent = original;
          err.hidden = false;
          err.textContent = (e && (e.description || e.message))
            ? (e.description || e.message)
            : _ocT('No hemos podido continuar. Inténtalo de nuevo o usa «Añadir a la cesta».', 'Impossible de continuer. Réessayez ou utilisez « Ajouter au panier ».', 'Não foi possível continuar. Tente novamente ou use «Adicionar ao cesto».');
        });
    });
  }

  function scan() {
    var forms = document.querySelectorAll('form.form-card');
    for (var i = 0; i < forms.length; i++) build(forms[i]);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      pending = false;
      scan();
    }, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var mo = new MutationObserver(schedule);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
